// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__Vi3tK","loader":"Loader_loader__QXXr7","loader_animation":"Loader_loader_animation__g6ScD"};